export const colors = {
  background: "#17171B",
  backgroundLight: "#101012",
  primary: "#F6CF00",
  grey: "#EFEFEF",
  black: "#F8F8F8",
};

export const fontFamilies = {
  heading: "'Work Sans', sans-serif",
  body: "'Work Sans', sans-serif",
};

export const horizontalPadding = "clamp(1rem, 4vw, 5rem)";

const theme = {
  colors,
  fontFamilies,
  horizontalPadding,
};

export default theme;
